import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=a1e07f64&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Player.vue?vue&type=style&index=1&id=a1e07f64&lang=scss&scoped=true&"
import style2 from "./Player.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e07f64",
  null
  
)

export default component.exports